import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from "react";
import { SubConfigurationController } from "@plansoft-configuration-renderer/framework";
import { NestedLayout } from "@plansoft-configuration-renderer/layout";
import { LayoutAttributeStrategy } from "../../AttributeStrategy/LayoutAttributeStrategy";
/**
 * The content of a single instance of a sub configuration attribute
 *
 * The substructure passed in as props can be a stub without attributes.
 *
 * When this is rendered, it triggers a fetch of the full sub configuration.
 *
 * @param props
 * @returns
 */
export function SubstructureContent(props) {
    const { substructure, FallbackUi = Fragment, LoadingIndicator = Fragment, } = props;
    return (_jsx(SubConfigurationController, { cfgObject: substructure, FallbackUi: FallbackUi, children: _jsx(NestedLayout, { children: _jsx(LayoutAttributeStrategy, { LoadingIndicator: LoadingIndicator }) }) }));
}
SubstructureContent.displayName = "SubstructureContent";
//# sourceMappingURL=SubstructureContent.js.map